export default "__VITE_ASSET__CQC9W6q0__"